// extracted by mini-css-extract-plugin
export default {"button":"TextButton_button__+zYRt"};